import { render, staticRenderFns } from "./not-generate-journal.vue?vue&type=template&id=bb2884e8&scoped=true"
import script from "./not-generate-journal.vue?vue&type=script&lang=js"
export * from "./not-generate-journal.vue?vue&type=script&lang=js"
import style0 from "./not-generate-journal.vue?vue&type=style&index=0&id=bb2884e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2884e8",
  null
  
)

export default component.exports